import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import { infoBlockWrapper } from '@/components/UserProfile/styles.ts';
import Modal from '@/animations/Modal.tsx';
import { ReportModal } from '@/components/Messanger/ReportModal.tsx';
import { RelationKind } from '@/enums/apiEnums.ts';
import { reportAction } from '@/components/Popup/UserProfile/styles.ts';

type ReportBlockProps = {
  hid: string;
  name: string;
  relationKind: RelationKind;
};

export const ReportBlock = ({ hid, name, relationKind }: ReportBlockProps) => {
  const { t } = useTranslation();
  const [reportOpen, setReportOpen] = useState(false);

  const openReport = () => setReportOpen(true);
  const closeReport = () => setReportOpen(false);

  return (
    <>
      <InputContent style={{ marginTop: 10, marginBottom: 10 }}>
        <div style={infoBlockWrapper} onClick={openReport}>
          <div style={reportAction}>{t('report_action')}</div>
        </div>
      </InputContent>
      <Modal open={reportOpen} handleClose={closeReport}>
        <ReportModal
          id={hid}
          name={name}
          handleClose={closeReport}
          relationKind={relationKind}
        />
      </Modal>
    </>
  );
};
